import script from "./ProductCardPrices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardPrices.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardPrices.vue?vue&type=style&index=0&id=ec01d41a&lang=scss"

const __exports__ = script;

export default __exports__